import "./AppIcon.scss"
import React from "react"
import Icon from "./Icon"

const AppIcon = () => {
  return (
    <div className="AppIcon">
      <Icon name="chat" size={14} color="white" type="legacy" />
    </div>
  )
}

AppIcon.displayName = "AppIcon"

export default AppIcon



// WEBPACK FOOTER //
// ./src/lib/AppIcon.js